import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { user } from "@/hooks/firestore/models/user";

const useUser = () => {
  const { data, error, isLoading } = useFirestore("/users/{userId}", user);

  return {
    user: data,
    error,
    isLoading,
  } as const;
};

export { useUser };
